export const DEFAULT_METERS = 3000;
export const DEFAULT_KILOMETERS = DEFAULT_METERS / 1000;

export const LOCATION_TYPES = {
  mapSearch: 'mapSearch',
};
